import React, { useState, useEffect, useRef, useCallback } from "react";
import $ from "jquery";
import _ from "lodash";
import { Link, NavLink } from "react-router-dom";
import TopNav from "../../commonUI/TopHeader/TopHeader";
import {
  setQuote,
  forcePaymentCompleted,
} from "../../../services/adminService";
import { retrieveQuote } from "../../../services/jobService";
import {
  showSpinner,
  closeSpinner,
  modal,
  confirm,
} from "../../../js/modules/Dialogs";
import {
  sessionExpired,
  adminSaveChangesConfirm,
  adminJobAlreadyClosed,
  adminJobAlreadyComplete,
  adminJobAlreadyPaid,
  adminQuoteAlreadyPaidPrice,
  adminQuoteArchived,
  adminQuoteOpenOther,
  adminQuoteClosed,
  adminQuoteAlreadyPaidSetAny,
} from "../../../config/messages";
import {
  serverUrl,
  quoteImagesFolder,
  thumbSuffix,
  imageFormat,
  userImagesFolder,
  defaultAvatarImage,
  jobImagesFolder,
} from "../../../config/env";
import {
  defaultCommission,
  defaultMessagesFilter,
} from "../../../config/constants";
import {
  validate_customerprice,
  calculatePricesWithCommission,
  validate_price,
} from "../../../js/modules/Generic";
import { toScreen } from "../../../js/modules/Routing";
import AuditNotes from "../../commonUI/AuditNotes";
import PropTypes from "prop-types";
import withNavigate from "../withNavigate";
import {
  BackArrowIcon,
  BellIcon,
  BellSlashIcon,
  DiscountIcon,
  EditIcon,
  EmailIcon,
  MessageIcon,
  StarEmptyIcon,
  StarIcon,
  ViewInStripe,
} from "../../commonUI/Icons/SvgIcon";
import ClientEdit from "../Clients/ClientEdit";
import { Box, Drawer } from "@mui/material";
import QuoteEdit from "./QuoteEdit";

const Quote = ({ userDetails, quoteId, updateState, navigate }) => {
  const [state, setState] = React.useState({
    right: false,
  });
  const [currentView, setCurrentView] = useState(null);
  const [selectedQuote, setSelectedQuote] = useState(null);
  const [activeTab, setActiveTab] = useState("jobdetails");

  const ref = useRef();
  const [creationDate, setCreationDate] = useState("");
  const [originalStatus, setOriginalStatus] = useState("");
  const [quotePriceForMav, setQuotePriceForMav] = useState("");
  const [quotePriceForCommission, setQuotePriceForCommission] = useState("");
  const [theReview, setTheReview] = useState({
    comment: "",
    stars: 5,
  });
  const [quote, setQuote] = useState({
    _id: "",
    short_id: "",
    notes: [],
    _creator: {
      short_id: "",
      accountInfo: {
        username: "",
        avatar: "",
      },
    },
    quoteSpec: {
      price: "",
      itemDescription: "",
      numberMen: "",
      numberVans: "",
      images: [],
      deleteImages: [],
    },
    status: "",
    jobChanged: false,
    job: {
      _id: "",
      status: "",
      paymentType: "",
      mavPayment: "",
      _creator: {
        accountInfo: {
          username: "",
        },
        short_id: "",
      },
      commission: "",
    },
    conversationOpen: false,
  });

  const updateNotes = (newNotes, theCallback) => {
    if (!_.isEqual(newNotes, quote.notes)) {
      setQuote((prevQuote) => ({
        ...prevQuote,
        notes: newNotes,
      }));
      if (theCallback) {
        theCallback();
      }
    } else if (theCallback) {
      theCallback();
    }
  };

  const discardChanges = (event) => {
    if (event) {
      event.preventDefault();
    }
    toScreen(false, navigate, "/quotes");
  };

  const getQuote = async () => {
    showSpinner();

    try {
      const theQuote = {
        accountInfo: {
          username: userDetails.accountInfo.username,
          email: userDetails.accountInfo.email,
        },
        short_id: quoteId ?? window.location.pathname?.split("/")[2],
      };

      const resJson = await retrieveQuote(theQuote);

      closeSpinner();

      setCreationDate(resJson.theQuote.creationDate);
      setOriginalStatus(resJson.theQuote.status);
      setTheReview(
        resJson.ratings && _.size(resJson.ratings) > 0
          ? {
              stars: resJson.ratings[0].stars,
              comment: resJson.ratings[0].comment,
            }
          : { stars: false, comment: false },
      );
      setQuote({
        ...resJson.theQuote,
        quoteSpec: {
          ...resJson.theQuote.quoteSpec,
          deleteImages: [],
        },
      });

      // Set prices after state update
      setTimeout(() => {
        setPrices("quote.quoteSpec.price", resJson.theQuote.quoteSpec?.price);
      }, 0);
    } catch (error) {
      closeSpinner();
      if (error.response?.status === 401) {
        modal(sessionExpired);
        toScreen(false, navigate, "/logout");
      } else if (error.response?.status === 400) {
        modal(error.message);
        toScreen(false, navigate, "/quotes");
      } else {
        alert("Error fetching quote: " + error?.message);
      }
    }
  };

  const saveQuote = (event) => {
    if (event) {
      event.preventDefault();
    }

    confirm(false, adminSaveChangesConfirm, "Cancel", "Save", async () => {
      showSpinner();

      try {
        const theQuote = {
          _id: quote._id,
          short_id: quote.short_id,
          notes: quote.notes,
          mavPayment: quote.job.mavPayment,
          quoteSpec: {
            price: quote.quoteSpec?.price,
            numberMen: quote.quoteSpec.numberMen,
            numberVans: quote.quoteSpec.numberVans,
            deleteImages: quote.quoteSpec.deleteImages,
          },
          commission: quote.job.commission,
          status: quote.status,
        };

        const resJson = await setQuote(theQuote);

        closeSpinner();

        modal(resJson?.message || "Quote saved successfully", false, () => {
          toScreen(false, navigate, "/quotes");
        });
      } catch (error) {
        closeSpinner();
        if (error.response?.status === 401) {
          modal(sessionExpired);
          toScreen(false, navigate, "/logout");
        } else if (error.response?.status === 400) {
          modal(error.message);
        } else {
          alert("Error saving quote: " + error?.message);
        }
      }
    });
  };

  const handleForcePaymentCompleted = (event) => {
    if (event) {
      event.preventDefault();
    }

    confirm(
      false,
      "This action will check, if any stripe payment found against this quote. If found the job & quote status will be updated accordingly",
      "Cancel",
      "Continue",
      async () => {
        showSpinner();

        try {
          const theData = {
            data: {
              quote: quote._id,
              job: quote.job._id,
              mav: quote._creator._id,
            },
          };

          const resJson = await forcePaymentCompleted(theData);

          closeSpinner();

          modal(
            resJson?.message || "Payment processing completed",
            false,
            () => {
              window.location.reload(true);
            },
          );
        } catch (error) {
          closeSpinner();
          if (error.response?.status === 401) {
            modal(sessionExpired);
            toScreen(false, navigate, "/logout");
          } else if (error.response?.status === 400) {
            modal(error.message);
          } else if (error.response?.status === 500) {
            modal(error.message || "Server error");
          } else {
            alert("Error processing force payment: " + error?.message);
          }
        }
      },
    );
  };

  const renderImages = (key) => {
    const image = quote.quoteSpec.images[key];

    return (
      <div className="l-col-18" key={key}>
        <div className="c-avatar">
          <div className="c-avatar__pic-wrap">
            <img
              src={
                serverUrl +
                quoteImagesFolder +
                "/" +
                quote._id +
                "/" +
                image +
                thumbSuffix +
                imageFormat
              }
              alt={"image " + image}
              className="c-avatar__pic"
            />
          </div>
          <button value={image} onClick={(e) => deleteImage(e)}>
            Delete Image
          </button>
        </div>
      </div>
    );
  };

  const setPrices = (theName, theValue) => {
    var thePrices;

    if (theName == "quote.quoteSpec.price") {
      if (
        validate_customerprice(
          theValue,
          theValue,
          quote.job.commission || defaultCommission,
        )
      ) {
        thePrices = calculatePricesWithCommission(
          false,
          theValue,
          quote.job.commission || defaultCommission,
        );

        setQuotePriceForCommission(thePrices?.commission);
        setQuotePriceForMav(thePrices?.basePrice);
      } else {
        setQuotePriceForCommission("");
        setQuotePriceForMav("");
      }
    } else if (theName == "quotePriceForMav") {
      if (validate_price(theValue)) {
        thePrices = calculatePricesWithCommission(
          theValue,
          false,
          quote.job.commission || defaultCommission,
        );

        setQuotePriceForCommission(thePrices?.commission);
        setQuote((prevQuote) => ({
          ...prevQuote,
          quoteSpec: {
            ...prevQuote.quoteSpec,
            price: thePrices?.totalPrice,
          },
        }));
      } else {
        setQuotePriceForCommission("");
        setQuote((prevQuote) => ({
          ...prevQuote,
          quoteSpec: {
            ...prevQuote.quoteSpec,
            price: "",
          },
        }));
      }
    }
  };

  const handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    var oldValue = false;

    const inputChangeCallback = () => {
      setPrices(name, value);

      if (
        (name == "quote.quoteSpec.price" &&
          !validate_customerprice(
            value,
            value,
            quote.job.commission || defaultCommission,
          )) ||
        (name == "quotePriceForMav" && !validate_price(value))
      ) {
        setQuotePriceForCommission("");
        setQuotePriceForMav("");
        setQuote((prevQuote) => ({
          ...prevQuote,
          quoteSpec: {
            ...prevQuote.quoteSpec,
            price: "",
          },
        }));
      }
    };

    // CONTENT CHANGES
    if (originalStatus === "closed" && name !== "quote.status") {
      modal(adminJobAlreadyClosed);
    } else if (originalStatus === "complete" && name !== "quote.status") {
      modal(adminJobAlreadyComplete);
    } else if (originalStatus === "complete" && name !== "quote.status") {
      modal(adminJobAlreadyPaid);
    } else if (originalStatus === "paid" && name !== "quote.status") {
      modal(adminQuoteAlreadyPaidPrice);
    } else if (quote.archived && name !== "quote.status") {
      modal(adminQuoteArchived);
      // STATUS CHANGES
    } else if (
      name === "quote.status" &&
      originalStatus === "open" &&
      value !== "open" &&
      value !== "closed"
    ) {
      modal(adminQuoteOpenOther);
    } else if (
      name === "quote.status" &&
      originalStatus === "closed" &&
      value !== "open" &&
      value !== "closed"
    ) {
      modal(adminQuoteClosed);
    } else if (
      name === "quote.status" &&
      originalStatus == "complete" &&
      value !== "complete"
    ) {
      modal(adminJobAlreadyComplete);
    } else if (name === "quote.status" && quote.archived) {
      modal(adminQuoteArchived);
    } else if (
      name === "quote.status" &&
      originalStatus === "paid" &&
      value !== "paid"
    ) {
      modal(adminQuoteAlreadyPaidSetAny);
      // OTHER CHANGES
    } else if (name.split(".").length == 1) {
      if (name === "quotePriceForMav") {
        setQuotePriceForMav(value);
      }
      inputChangeCallback();
    } else if (name.split(".").length == 2) {
      const [firstKey, secondKey] = name.split(".");
      if (firstKey === "quote") {
        setQuote((prevQuote) => ({
          ...prevQuote,
          [secondKey]: value,
        }));
      }
      inputChangeCallback();
    } else if (name.split(".").length == 3) {
      const [firstKey, secondKey, thirdKey] = name.split(".");
      if (firstKey === "quote") {
        setQuote((prevQuote) => ({
          ...prevQuote,
          [secondKey]: {
            ...prevQuote[secondKey],
            [thirdKey]: value,
          },
        }));
      }
      inputChangeCallback();
    }
  };

  const deleteImage = (event) => {
    if (event) {
      event.preventDefault();
    }

    var newDeleteImages = quote.quoteSpec.deleteImages.slice(0);
    var newImages = quote.quoteSpec.images.slice(0);

    if (newDeleteImages.indexOf(parseInt(event.target.value)) == -1) {
      newDeleteImages.push(parseInt(event.target.value));
    }

    if (newImages.indexOf(parseInt(event.target.value)) != -1) {
      newImages.splice(newImages.indexOf(parseInt(event.target.value)), 1);
    }

    setQuote((prevQuote) => ({
      ...prevQuote,
      quoteSpec: {
        ...prevQuote.quoteSpec,
        deleteImages: newDeleteImages,
        images: newImages,
      },
    }));
  };

  useEffect(() => {
    getQuote();
  }, []);

  const toggleDrawer =
    (anchor, open, view = null, quote = null) =>
    (event) => {
      if (
        event.type === "keydown" &&
        (event.key === "Tab" || event.key === "Shift")
      ) {
        return;
      }

      setState({ ...state, [anchor]: open });

      if (open) {
        setCurrentView(view);
        if (quote) {
          setSelectedQuote(quote);
        } else {
          setSelectedQuote(null);
        }
      }
    };

  const list = (anchor) => (
    <Box
      sx={{ width: 600 }}
      role="presentation"
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
    >
      <QuoteEdit
        view={currentView}
        quote={selectedQuote}
        onClose={toggleDrawer(anchor, false)}
        userDetails={userDetails}
        quotePriceForCommission={quotePriceForCommission}
        quotePriceForMav={quotePriceForMav}
      />
    </Box>
  );

  const getAvatarSrc = useCallback((quote) => {
    if (
      quote._creator?.accountInfo?.avatar &&
      quote._creator?.accountInfo?.avatar !== ""
    ) {
      return `${serverUrl}${userImagesFolder}/${quote?.short_id}/${quote._creator?.accountInfo?.avatar}${thumbSuffix}${imageFormat}`;
    }
    return `../img/${defaultAvatarImage}${imageFormat}`;
  }, []);

  const getJobDetailsSrc = useCallback((shortId, image) => {
    if (image) {
      return `${serverUrl}${jobImagesFolder}/${shortId}/${image}${thumbSuffix}${imageFormat}`;
    }
    return `../img/${DefaultImage}${imageFormat}`;
  }, []);

  return (
    <>
      <TopNav title={"Quote details:"} shortId={quote.short_id} />
      <div className="global-body">
        <div className="global-body-container">
          <>
            <button
              className="btn-outline-light icon-with-btn"
              onClick={() => navigate("/quotes")}
            >
              <BackArrowIcon />
              Back to Quotes
            </button>
            <section className="tabing-section mt-16">
              {/* Left Side Content */}
              <div className="tab-content">
                <div className="quote-details-wrap mb-24">
                  <div className="title-section">
                    <div>
                      <h3 className="font-semibold tracking-tight text-xl mb-0">
                        Quotes details
                      </h3>
                      <span className="text-sm text-gray-500 text-capitalize">
                        {quote?.short_id?.toUpperCase()}
                      </span>
                    </div>
                    {["right"].map((anchor) => (
                      <React.Fragment key={anchor}>
                        <button
                          className="btn-warning icon-with-btn"
                          onClick={toggleDrawer(
                            anchor,
                            true,
                            "editquotedetails",
                            quote,
                          )}
                        >
                          <EditIcon />
                          Edit
                        </button>
                        <Drawer
                          anchor={anchor}
                          open={state[anchor]}
                          onClose={toggleDrawer(anchor, false)}
                          ModalProps={{
                            BackdropProps: {
                              style: {
                                backgroundColor: "rgba(0, 0, 0, 0.1)",
                              },
                            },
                          }}
                          sx={{
                            boxShadow: "none",
                            "& .MuiDrawer-paper": { boxShadow: "none" },
                          }}
                        >
                          {list(anchor)}
                        </Drawer>
                      </React.Fragment>
                    ))}
                  </div>
                  <div className="quote-profile">
                    <div className="d-flex align-items-center g-12">
                      <img
                        src={getAvatarSrc(quote)}
                        alt="avatar"
                        className="avatar-pic"
                        onError={(e) => {
                          e.target.src = defaultAvatarImage;
                        }}
                      />
                      <div>
                        <h4 className="mb-0 text-lg text-capitalize">
                          {quote._creator.accountInfo.username}
                        </h4>
                        <div className="client-details">
                          <span className="text-sm text-gray-500">
                            {quote?.accountInfo?.email}
                          </span>
                        </div>
                        <div className="client-rating-info">
                          <StarEmptyIcon />
                          <p>
                            {quote?._creator?.ratingAsMav ?? 0}{" "}
                            <i className="fa-solid fa-star"></i>
                          </p>

                          <a
                            onClick={(e) => {
                              quote?._creator?.totalRatings &&
                              quote?._creator?.totalRatings > 0
                                ? toScreen(
                                    e,
                                    navigate,
                                    "/quote/" + quote?.short_id + "/reviews",
                                    false,
                                    {
                                      receiverId: quote?._id,
                                      receiverShortId: quote?.short_id,
                                      receiverType: quote?.userType,
                                      userShortId1: "admin",
                                      userShortId2: quote?.short_id,
                                      username2: quote?.accountInfo?.username,
                                      selectedPage:
                                        window.history.state.usr
                                          ?.selectedPage ?? 1,
                                      selectedFilter:
                                        window.history.state.usr
                                          ?.selectedFilter ??
                                        defaultMessagesFilter,
                                      previousPath:
                                        window.history.state.usr
                                          ?.previousPath ??
                                        window.location.pathname,
                                    },
                                  )
                                : null;
                            }}
                            title=""
                            className="text-sm total-rating"
                          >
                            ({quote?._creator?.totalRatings ?? 0} reviews)
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex align-items-center g-8 ms-auto">
                      <button
                        className="btn-outline-light icon-with-btn"
                        onClick={(e) =>
                          toScreen(
                            e,
                            navigate,
                            "/message/" + quote?.short_id,
                            false,
                            {
                              receiverId: quote?._id,
                              receiverShortId: quote?.short_id,
                              receiverType: quote?.userType,
                              userShortId1: "admin",
                              userShortId2: quote?.short_id,
                              username2: quote?.accountInfo?.username,
                              selectedPage:
                                window.history.state.usr?.selectedPage ?? 1,
                              selectedFilter:
                                window.history.state.usr?.selectedFilter ??
                                defaultMessagesFilter,
                              previousPath:
                                window.history.state.usr?.previousPath ??
                                window.location.pathname,
                            },
                          )
                        }
                      >
                        <MessageIcon />
                        {quote?.accountInfo?.firstname}
                      </button>
                      <button
                        className="btn-outline-light icon-with-btn"
                        onClick={(e) =>
                          toScreen(
                            e,
                            navigate,
                            `/mav/${quote?._creator?.short_id}`,
                          )
                        }
                      >
                        Details
                      </button>
                    </div>
                  </div>
                  <div className="p-24">
                    <ul className="profile-info">
                      <li className="profile-info-item">
                        <span className="profile-info-title">Status</span>
                        <p
                          className={`text-capitalize badge  ${
                            quote?.status === "open"
                              ? "badge-info"
                              : quote?.status === "closed"
                                ? "badge-danger"
                                : quote?.status === "paid"
                                  ? "badge-warning"
                                  : quote?.status === "complete"
                                    ? "badge-success"
                                    : ""
                          }`}
                        >
                          {quote?.status}
                        </p>
                      </li>
                      <li className="profile-info-item">
                        <span className="profile-info-title">Posted on</span>
                        <p>
                          {quote?.creationDate},{quote?.creationTime}
                        </p>
                      </li>
                      <li className="profile-info-item">
                        <span className="profile-info-title">Vans & Men</span>
                        <p>
                          {quote?.quoteSpec?.numberVans} van,{" "}
                          {quote?.quoteSpec?.numberMen} men
                        </p>
                      </li>
                      <li className="profile-info-item">
                        <span className="profile-info-title">Price quoted</span>
                        <p>£{quotePriceForMav}</p>
                      </li>
                      <li className="profile-info-item">
                        <span className="profile-info-title">MAV fee</span>
                        <p>£{quotePriceForCommission}</p>
                      </li>
                      <li className="profile-info-item">
                        <span className="profile-info-title">
                          Cost for customer
                        </span>
                        <p>£{quote.quoteSpec?.price}</p>
                      </li>
                    </ul>

                    <div className="quote-msg-wrap">
                      <p className="text-sm text-gray-500">Quote message</p>
                      <div className="quote-msg">
                        {quote?.quoteSpec?.message?.message}
                      </div>
                      <div className="d-flex align-items-center g-12 mt-16">
                        <button
                          className="btn-outline-light icon-with-btn"
                          onClick={(e) =>
                            toScreen(
                              e,
                              navigate,
                              "/message/" + quote?.short_id,
                              false,
                              {
                                receiverId: quote?._id,
                                receiverShortId: quote?.short_id,
                                receiverType: quote?.userType,
                                userShortId1: "admin",
                                userShortId2: quote?.short_id,
                                username2: quote?.accountInfo?.username,
                                selectedPage:
                                  window.history.state.usr?.selectedPage ?? 1,
                                selectedFilter:
                                  window.history.state.usr?.selectedFilter ??
                                  defaultMessagesFilter,
                                previousPath:
                                  window.history.state.usr?.previousPath ??
                                  window.location.pathname,
                              },
                            )
                          }
                        >
                          <MessageIcon />
                          View Driver/Client conversation
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="detailsCard">
                  <div className="custom-tabs m-0">
                    <div
                      className={`tab-item ${
                        activeTab === "jobdetails" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("jobdetails")}
                    >
                      Job Details
                    </div>
                    <div
                      className={`tab-item ${
                        activeTab === "client" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("client")}
                    >
                      Client
                    </div>
                    <div
                      className={`tab-item ${
                        activeTab === "driver" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("driver")}
                    >
                      Driver
                    </div>
                  </div>
                  {/* Profile Info */}
                  {activeTab === "jobdetails" && (
                    <>
                      <div className="quote-profile">
                        <div className="d-flex align-items-center g-12">
                          <div>
                            <div className="d-flex align-items-center g-8">
                              <h4 className="mb-0 text-lg text-capitalize">
                                {quote._creator.accountInfo.username}
                              </h4>
                              <span
                                className={`text-capitalize badge  ${
                                  quote?.status === "open"
                                    ? "badge-info"
                                    : quote?.status === "closed"
                                      ? "badge-danger"
                                      : quote?.status === "paid"
                                        ? "badge-warning"
                                        : quote?.status === "complete"
                                          ? "badge-success"
                                          : ""
                                }`}
                              >
                                {quote?.status}
                              </span>
                            </div>

                            <p className="text-sm text-gray-600 text-capitalize">
                              {quote?.job?.short_id}
                            </p>
                          </div>
                        </div>
                        <div className="d-flex align-items-center g-12 ms-auto">
                          <button className="btn-outline-light icon-with-btn">
                            Details
                          </button>
                        </div>
                      </div>
                      <div className="p-24">
                        <div className="job-images">
                          {quote?.quoteSpec?.images?.length > 1 &&
                            quote?.quoteSpec?.images?.map((image, index) => (
                              <div className="job-image" key={index}>
                                <img
                                  src={getJobDetailsSrc(
                                    quote?.quoteSpec?.shortId,
                                    image,
                                  )}
                                  alt={`Job image ${index + 1}`}
                                  className="c-avatar__pic"
                                  onError={(e) => {
                                    e.target.src = DefaultImage;
                                  }}
                                />
                              </div>
                            ))}
                        </div>

                        <ul className="profile-info">
                          <li className="profile-info-item">
                            <span className="profile-info-title">
                              Posted on
                            </span>
                            <p>{quote?.accountInfo?.firstname || "-"}</p>
                          </li>
                          <li className="profile-info-item">
                            <span className="profile-info-title">
                              Quotes received
                            </span>
                            <p>{quote?.accountInfo?.surname || "-"}</p>
                          </li>
                          <li className="profile-info-item">
                            <span className="profile-info-title">From</span>
                            <p>{quote?.accountInfo?.username || "-"}</p>
                          </li>
                          <li className="profile-info-item">
                            <span className="profile-info-title">To</span>
                            <p>{quote?.accountInfo?.email || "-"}</p>
                          </li>
                        </ul>
                      </div>
                    </>
                  )}
                  {/* Notification List */}
                  {activeTab === "client" && (
                    <>
                      <div className="quote-profile">
                        <div className="d-flex align-items-center g-12">
                          <div>
                            <h4 className="mb-0 text-lg text-capitalize">
                              {quote?._creator?.accountInfo?.username}
                            </h4>
                            <div className="client-details">
                              <span className="text-sm text-gray-500">
                                {quote?.accountInfo?.email}
                              </span>
                            </div>
                            <p className="text-sm text-gray-600">
                              {quote?._creator?.short_id}
                            </p>
                          </div>
                        </div>
                        <div className="d-flex align-items-center g-12 ms-auto">
                          <button
                            className="btn-outline-light icon-with-btn"
                            onClick={(e) =>
                              toScreen(
                                e,
                                navigate,
                                "/message/" + quote?._creator?.short_id,
                                false,
                                {
                                  receiverId: quote?._id,
                                  receiverShortId: quote?._creator?.short_id,
                                  receiverType: quote?.userType,
                                  userShortId1: "admin",
                                  userShortId2: quote?.short_id,
                                  username2: quote?.accountInfo?.username,
                                  selectedPage:
                                    window.history.state.usr?.selectedPage ?? 1,
                                  selectedFilter:
                                    window.history.state.usr?.selectedFilter ??
                                    defaultMessagesFilter,
                                  previousPath:
                                    window.history.state.usr?.previousPath ??
                                    window.location.pathname,
                                },
                              )
                            }
                          >
                            <MessageIcon />
                            {quote?.accountInfo?.firstname}
                          </button>
                          <button
                            className="btn-outline-light icon-with-btn"
                            onClick={(e) =>
                              toScreen(
                                e,
                                navigate,
                                `/client/${quote?._creator?.short_id}`,
                              )
                            }
                          >
                            Details
                          </button>
                        </div>
                      </div>

                      <ul className="profile-info p-24">
                        <li className="profile-info-item">
                          <span className="profile-info-title">Phone</span>
                          <p>{quote?._creator?.phone || "-"}</p>
                        </li>
                        <li className="profile-info-item">
                          <span className="profile-info-title">Email</span>
                          <p className="word-wrap">
                            {quote?._creator?.email || "-"}
                          </p>
                        </li>
                        <li className="profile-info-item">
                          <span className="profile-info-title">Jobs</span>
                          <p>{quote?._creator?.jobs || "-"}</p>
                        </li>
                        <li className="profile-info-item">
                          <span className="profile-info-title">Registered</span>
                          <p>{quote?._creator?.registered || "-"}</p>
                        </li>
                      </ul>
                    </>
                  )}

                  {/* {Driver list} */}
                  {activeTab === "driver" && (
                    <>
                      <div className="quote-profile">
                        <div className="d-flex align-items-center g-12">
                          <img
                            src={getAvatarSrc(quote)}
                            alt="avatar"
                            className="avatar-pic"
                            onError={(e) => {
                              e.target.src = defaultAvatarImage;
                            }}
                          />
                          <div>
                            <h4 className="mb-0 text-lg text-capitalize">
                              {quote._creator.accountInfo.username}
                            </h4>
                            <div className="client-details">
                              <span className="text-sm text-gray-500">
                                {quote?.accountInfo?.email}
                              </span>
                            </div>
                            <p className="text-sm text-gray-600">PKC3LV8T8</p>
                          </div>
                        </div>
                        <div className="d-flex align-items-center g-12 ms-auto">
                          <button
                            className="btn-outline-light icon-with-btn"
                            onClick={(e) =>
                              toScreen(
                                e,
                                navigate,
                                "/message/" + quote?.short_id,
                                false,
                                {
                                  receiverId: quote?._id,
                                  receiverShortId: quote?.short_id,
                                  receiverType: quote?.userType,
                                  userShortId1: "admin",
                                  userShortId2: quote?.short_id,
                                  username2: quote?.accountInfo?.username,
                                  selectedPage:
                                    window.history.state.usr?.selectedPage ?? 1,
                                  selectedFilter:
                                    window.history.state.usr?.selectedFilter ??
                                    defaultMessagesFilter,
                                  previousPath:
                                    window.history.state.usr?.previousPath ??
                                    window.location.pathname,
                                },
                              )
                            }
                          >
                            <MessageIcon />
                            {quote?.accountInfo?.firstname}
                          </button>
                          <button
                            className="btn-outline-light icon-with-btn"
                            onClick={(e) =>
                              toScreen(
                                e,
                                navigate,
                                `/mav/${quote?._creator?.short_id}`,
                              )
                            }
                          >
                            Details
                          </button>
                        </div>
                      </div>

                      <ul className="profile-info p-24">
                        <li className="profile-info-item">
                          <span className="profile-info-title">Rating</span>
                          {/* <p>
                            {quote?._creator?.ratingAsMav} <StarIcon /> ({" "}
                            {quote?._creator?.totalRatings} reviews)
                          </p> */}
                          <div className="client-rating-info">
                            <p>{quote?._creator?.ratingAsMav}</p>
                            <StarIcon />({quote?._creator?.totalRatings}{" "}
                            reviews)
                          </div>
                        </li>
                        <li className="profile-info-item">
                          <span className="profile-info-title">Phone</span>
                          <p>{quote?._creator?.phone || "-"}</p>
                        </li>
                        <li className="profile-info-item">
                          <span className="profile-info-title">Email</span>
                          <p className="word-wrap">
                            {quote?._creator?.email || "-"}
                          </p>
                        </li>
                        <li className="profile-info-item">
                          <span className="profile-info-title">Joined</span>
                          <p>{quote?._creator?.joined || "-"}</p>
                        </li>
                      </ul>
                    </>
                  )}
                </div>
              </div>

              <AuditNotes
                ref={ref}
                notes={quote?.notes}
                updateNotes={updateNotes}
              />
            </section>
            {quote.quoteSpec.images.length != 0 ? (
              <div className="c-hr"></div>
            ) : (
              ""
            )}
            <div className="l-row">
              {Object.keys(quote?.quoteSpec?.images || {}).map(renderImages)}
            </div>{" "}
          </>
        </div>
      </div>
    </>
  );
};

Quote.contextTypes = {
  router: PropTypes.object,
};

Quote.propTypes = {
  userDetails: PropTypes.object.isRequired,
  quoteId: PropTypes.string.isRequired,
  updateState: PropTypes.func.isRequired,
};

export default withNavigate(Quote);
